import {
  Box,
  Chip,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  Button,
  Switch,
  ButtonGroup,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import SubtitleTypography from "../../../components/typography/SubtitleTypography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Remove as RemoveIcon } from "@mui/icons-material";
import { AddIcon } from "@chakra-ui/icons";
import ParagraphTypography from "../../../components/typography/ParagraphTypography";
import TempleImg from "../../../assets/temple-icon.png";
import LocationImg from "../../../assets/loc-icon.png";
import { PersonPinCircleOutlined as PersonPinCircleOutlinedIcon } from "@mui/icons-material";
import { East as EastIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import couponApplyIcon from "../../../assets/coupon-tick.png";
import couponPercentIcon from "../../../assets/coupon-percent.png";

import React, { useEffect, useState } from "react";
import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  CHADHAVA_ADDON_SCROLL_RESPONSIVE,
  LOCALSTORAGE_KEY,
} from "../../../utils/Constants";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import Carousel from "react-multi-carousel";

import Dialog from "@mui/material/Dialog";
import ChooseAddress from "../../../components/chooseaddress/ChooseAddress";
import "./CartView.scss";
import CouponCodeDialog from "./CouponCodeDialog";
import { ErrorOutlineRounded as ErrorOutlineRoundedIcon } from "@mui/icons-material";
import { dakshinaPandit, orderType } from "../../../utils/Constants";
import DeleteConfirmDialog from "../../../components/dialog/DeleteConfirmDialog";
// import { getPriceConversionRate } from "../../../store/actions/priceConversionAction";
import prasadImg from "../../../assets/prasad-img.webp";
import AlertDialog from "../../../components/dialog/AlertDialog";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import {
  disclaimerPrasadText,
  POP_UP_MESSAGE,
} from "../../../utils/ConstantsMessages";
import {
  calculateOverSeasPrice,
  getMinimumPriceDataForChadhava,
  removeTimeFromOrderDate,
  getTempleName,
  getCityStateFromTemple,
  truncateToTwoDecimals,
  getDateFormatedForPujaDetails,
  getMinimumPrice,
  calculateDiscountedPrice,
} from "../../../utils/HelperFunctions";
import { LOCALIZATION } from "../../../utils/localization";
import { useTranslation } from "react-i18next";
import SelectPrasadPackageDilog from "../../../components/dialog/SelectPrasadPackageDilog";
import ImageView from "../../../components/ImageView/ImageView";
import CartPackageDetails from "../../../components/card/Cart/cartPackageDetaios/CartPackageDetails";
import ChadhavaItemList from "../../../components/chadhavaItemList/ChadhavaItemList";
import ChadhavaPlanSelector from "../../../components/chadhavaPlanSelector/ChadhavaPlanSelector";
import PujaPlanSelector from "../../../components/pujaPlanSelector/PujaPlanSelector";

function ReviewCartView(props: any) {
  const { t, i18n } = useTranslation();
  const priceData = props.priceBreakup;
  const userDetails = props.userDetails;
  const {
    isOverseas = false,
    getSymbolWithPrice,
    getChadhavaFinalPaymentValue,
  } = props;
  const {
    setOutSideIndiaMessagePopup,
    outSideIndiaMessagePopup,
    isPrasad,
    selectedAddressDetails,
    setIsPrasad,
    handlePrasadCheckboxChange,
    setChooseAddressBox,
    isCountryDisabledForBooking,
    isPrasadPkgOpen,
    setIsPrasadPkgOpen,
    selectedPrasadItem,
    setSelectedPrasadItem,
    handleSelectPrasadPkg,
    priceBreakup,
    currencySign,
    rate,
    selectedChadhavaSubscription,
    subscriptionChadhavaAggPrice,
    handleChadhavaPlanSelection,
    selectedPujaSubscription,
    handlePujaPlanSelection,
    singlePujaPrice,
  } = props;
  // const handleSetCouponApplyResponse = () => {
  //   props.setCouponApplyResponse({
  //     ...props.couponApplyResponse,
  //     isApplied: true,
  //   });
  //   props.setCouponPopUp(false);
  // };
  const [selectedDakshina, setSelectedDakshina] = useState<number | string>(0);
  const [isEditing, setIsEditing] = useState(false);
  const [customDakshina, setCustomDakshina] = useState<any>(0);
  const [
    openAlertDialogForBookingNotAllowed,
    setOpenAlertDialogForBookingNotAllowed,
  ] = useState<any>(false);
  const [openPriceErrorDialog, setOpenPriceErrorDialog] =
    useState<boolean>(false);
  const [isLoadingPayment, setIsLoadingPayment] = useState<boolean>(false);
  const cartDetails = props?.cartDetails ? props?.cartDetails : null;
  const templeDetails = props?.templeDetails ? props?.templeDetails : null;
  const memberDetails =
    props?.memberDetails && props?.memberDetails?.length > 0
      ? props?.memberDetails[0]
      : null;

  const chadhavaEnablity =
    cartDetails?.orderType === orderType.chadhava ? true : false;
  const prasadEnablity =
    cartDetails?.orderType === orderType.prasad ? true : false;
  const pujaEnablity = cartDetails?.orderType === orderType.puja ? true : false;
  const pujaPkgEnablity =
    cartDetails?.orderType === orderType.pujaPackage ? true : false;
  const chadhavaPkgEnablity =
    cartDetails?.orderType === orderType.chadhavaPackage ? true : false;

  const cartPageTitle =
    cartDetails?.orderType === orderType.chadhava ? "Chadhava" : "Prasad";

  // const chadhavaEnablity =  cartDetails?.orderType === orderType.chadhava ? true : false;
  // const prasadEnablity =  cartDetails?.orderType === orderType.prasad ? true : false;
  // const pujaEnablity =  cartDetails?.orderType === orderType.puja ? true : false;

  // const  cartPageTitle = cartDetails?.orderType === orderType.chadhava ? "Chadhava" : "Prasad";

  // const selectedChadhavaPackage = cartDetails?.selectedChadhavaPackage
  //   ? cartDetails?.selectedChadhavaPackage?.filter((item: any) => item?.count > 0)
  //   : [];
  // if (selectedChadhavaPackage.length === 0 && chadhavaEnablity) {
  //   props.handRedirectToChadhavaPage();
  // }
  // if (selectedChadhavaPackage.length === 0 && prasadEnablity) {
  //   // props.handRedirectToPrasadPage();
  // }

  useEffect(() => {
    if (cartDetails?.id) {
      setCustomDakshina(0);
      setSelectedDakshina(0);
      props?.setPanditDakshina(0);
      props?.setPanditCustomeDakshina(0);
    }
  }, [cartDetails?.id]);

  var selectedChadhavaPackage: any = [];
  if (chadhavaEnablity && cartDetails?.selectedChadhavaPackage?.length) {
    selectedChadhavaPackage = cartDetails?.selectedChadhavaPackage;
  } else if (prasadEnablity && cartDetails?.selectedPrasadPackage?.length) {
    selectedChadhavaPackage = cartDetails?.selectedPrasadPackage;
  } else if (
    cartDetails?.selectedChadhavaPackage?.length === 0 &&
    chadhavaEnablity
  ) {
    props.handRedirectToChadhavaPage();
  } else if (
    cartDetails?.selectedPrasadPackage?.length === 0 &&
    prasadEnablity
  ) {
    props.handRedirectToPrasadPage();
  } else {
    //do nothing
  }

  // add ons items

  let chadhavaList = [];

  if (chadhavaEnablity && cartDetails?.addOnChadhavaItems?.length) {
    chadhavaList = cartDetails?.addOnChadhavaItems
      ? cartDetails?.addOnChadhavaItems?.filter(
          (item: any) => item?.count === 0 && item.disabled === false
        )
      : [];
  } else if (prasadEnablity && cartDetails?.addOnPrasadItems?.length) {
    chadhavaList = cartDetails?.addOnPrasadItems;
  }

  const increment = (item: any) => {
    props.handleIncrement(item);
  };

  const decrement = (item: any) => {
    props.handleDecrement(item);
  };
  const addChadhava = (item: any) => {
    props.handleAddChadhava(item);
    // props.handleIncrement(item);
  };

  const handleLabelClick = () => {
    setIsEditing(true);
    if (customDakshina === "custom") {
      setCustomDakshina("");
    }
    setCustomDakshina("");
    props?.setPanditDakshina(0);
    setSelectedDakshina(0);
  };

  const isValidNumber = (value: any): boolean => {
    if (value.trim() === "") return true;

    const isNumber = !isNaN(value) && value.trim() !== "";
    const hasFourDigits = /^[0-9]{1,4}$/.test(value?.trim());
    return isNumber && hasFourDigits;
  };

  const handleSetCutstomDakshinaChange = (event: any) => {
    if (!isValidNumber(event.target.value)) return false;
    setSelectedDakshina(event.target.value);
    setCustomDakshina(event.target.value);
    props?.setPanditCustomeDakshina(event.target.value);
  };

  const handleSetCutstomDakshinaBlur = (e: any) => {
    if (!isValidNumber(e.target.value)) return false;
    setSelectedDakshina(e.target.value);
    setIsEditing(false);
    setCustomDakshina(e.target.value);
    props?.setPanditCustomeDakshina(e.target.value);
  };

  const handleSetCutstomDakshinaKeyDown = (event: any) => {
    if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
      event.preventDefault();
    }

    if (!isValidNumber(event.target.value)) return false;

    setSelectedDakshina(event.target.value);
    setCustomDakshina(event.target.value);
    props?.setPanditCustomeDakshina(event.target.value);
    if (event.key === "Enter") {
      setIsEditing(false); // Hide the TextField when Enter is pressed
    }
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirmDelete = () => {
    props.clearCart();
  };

  const handleCloseAlertDialogForBookingNotAllowed = () => {
    setOpenAlertDialogForBookingNotAllowed(false);
  };

  const handleCloseAlertDialogForPrice = () => {
    setOpenPriceErrorDialog(false);
  };

  const minOrderValue = getMinimumPriceDataForChadhava(cartDetails);

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeName = getTempleName(
    props?.cartDetails?.templeDetails,
    savedLanguage
  );

  const personalInfo = cartDetails?.templeDetails?.personalInfo;
  const templeAddress = getCityStateFromTemple(personalInfo);

  const handleClickProceedToPayment = async (e: any) => {
    try {
      if (isCountryDisabledForBooking) {
        setOpenAlertDialogForBookingNotAllowed(true);
        return;
      }
      let orderAmount = isOverseas
        ? calculateOverSeasPrice(
            props?.priceBreakup?.finalPrice,
            props?.rate,
            "number"
          )
        : props?.priceBreakup?.finalPrice;

      if (cartDetails?.orderType === orderType.chadhava) {
        const minOrderValueChadhava =
          getMinimumPriceDataForChadhava(cartDetails);
        if (
          isOverseas &&
          orderAmount < minOrderValueChadhava?.minBookingChadhavaPriceOverseas
        ) {
          setOpenPriceErrorDialog(true);
          return;
        }
        if (
          !isOverseas &&
          orderAmount < minOrderValueChadhava?.minBookingChadhavaPriceIND
        ) {
          setOpenPriceErrorDialog(true);
          return;
        }
      }
      setIsLoadingPayment(true);
      await Promise.resolve("");
      await props.placeOrder(e);
      setIsLoadingPayment(false);
    } catch (err: any) {
      setIsLoadingPayment(false);
    }
  };

  const [isAboveFooter, setIsAboveFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector(".footerArea");
      const button = document.querySelector(".sticky-button");
      if (footer && button) {
        const footerRect = footer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        if (
          footerRect.top < window.innerHeight &&
          footerRect.bottom >= buttonRect.bottom
        ) {
          setIsAboveFooter(true);
        } else {
          setIsAboveFooter(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const isMobile = useMediaQuery("(max-width:600px)");
  const itemsPerRow = isMobile ? 3 : 4;
  return (
    <Box className="secondStep AddDevoteeDetails">
      {chadhavaEnablity || prasadEnablity ? (
        <Box className="chadhavaDetails">
          <SubtitleTypography
            title={`${t(cartPageTitle)} ${t(LOCALIZATION.Review)} ${t(
              LOCALIZATION.Details,
            )}`}
          ></SubtitleTypography>
          {/* Add Devotee */}
          <Box className="addDevotee">
            <Box className="devoteeDetails">
              <SubtitleTypography
                title={t(LOCALIZATION.Devotee_Details)}
              ></SubtitleTypography>
              <Button
                className="editDevotee"
                onClick={() => {
                  props.editPujaOptions();
                }}
              >
                {t(LOCALIZATION.Edit)} {t(LOCALIZATION.Devotee)}
              </Button>
            </Box>

            <Box className="formGroup" mt={0}>
              <Box className="formField lightOpa">
                <label>{t(LOCALIZATION.Temple_Name)}</label>
                <TextField
                  fullWidth
                  id="standard-helperText"
                  value={`${templeDetails?.personalInfo?.name}`}
                  variant="standard"
                />
              </Box>
              {/* {memberDetails.map((item: any, id: any) => {
                return ( */}
              <Box className="formField lightOpa">
                <label>{t(LOCALIZATION.Full_Name_of_Devotee)} *</label>
                <TextField
                  fullWidth
                  id="standard-helperText"
                  value={memberDetails?.fullName}
                  variant="standard"
                />
              </Box>
              {/* );
              })} */}
              {!prasadEnablity ? (
                <Box className="formField lightOpa">
                  <label>
                    {t(LOCALIZATION.Gotram_Kashyap_Gotram_if_not_known)}
                  </label>
                  <TextField
                    fullWidth
                    id="standard-helperText"
                    value={
                      memberDetails?.gotram ? memberDetails?.gotram : "Kashyapa"
                    }
                    variant="standard"
                  />
                </Box>
              ) : (
                ""
              )}
              <Box className="formField lightOpa">
                <label>{t(LOCALIZATION.Provide_Your_WhatsApp_Number)} *</label>
                <TextField
                  fullWidth
                  id="standard-helperText"
                  value={`${cartDetails?.whatsAppNumberdialCode} ${cartDetails?.whatsAppNumber}`}
                  variant="standard"
                />
              </Box>
            </Box>
          </Box>

          {/* Address */}
          {prasadEnablity ? (
            userDetails ? (
              <>
                <Box className="cardDesign addressSce">
                  <Typography className="addressTitle">
                    {/* {" "}
                  {props.selectedAddressDetails
                    ? props.selectedAddressDetails.savedAs ||
                    props.selectedAddressDetails.name
                    : "Address"} */}
                    {t(LOCALIZATION.Delivery_address)}
                  </Typography>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    marginTop="10px"
                    spacing={1}
                    onClick={() => {
                      if (props.selectedAddressDetails) {
                        props.setChooseAddressBox(true);
                      } else {
                        props.navigateToAddressScreen();
                      }
                    }}
                  >
                    <Box className="addressText">
                      <PersonPinCircleOutlinedIcon />
                      {props.selectedAddressDetails ? (
                        <Box>
                          <Typography className="areaInfo">
                            {props.selectedAddressDetails.savedAs}
                          </Typography>
                          <Typography className="locationInfo">
                            {
                              props.selectedAddressDetails.formatted_address
                            }{" "}
                          </Typography>
                        </Box>
                      ) : (
                        <Box className="addressText">
                          <Typography>
                            {t(LOCALIZATION.Plese_Add_Your_Address)}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Box className="arrowBtn">
                      <Button variant="text">
                        <EastIcon />
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              </>
            ) : (
              // <Box className="logoutCartArea">
              //   <Box className="logoutCartAreaLeft">
              //     <Typography>
              //       {t(LOCALIZATION.You_Are_Not_Logged_In_Please_Login)}
              //     </Typography>
              //   </Box>
              //   <Box className="logoutCartAreaRight">
              //     <Button
              //       type="button"
              //       onClick={() => props.navigateToLoginScreen()}
              //     >
              //       {t(LOCALIZATION.Login_OR_Sign_up)}
              //     </Button>
              //   </Box>
              // </Box>
              " "
            )
          ) : (
            ""
          )}

          {/* SUBSCRIPTION LIST */}

          {chadhavaEnablity &&
            cartDetails?.isSubscribed &&
            cartDetails?.subscriptionChadhavas?.length && (
              <Box className="addDevotee chadhavaItems">
                <Box className="devoteeDetails">
                  <SubtitleTypography
                    title={`${t(LOCALIZATION.Chadhava_Subscription)} ${t(
                      LOCALIZATION.Items,
                    )}`}
                  ></SubtitleTypography>
                </Box>
                <Grid container spacing={2}>
                  {cartDetails?.subscriptionChadhavas?.map(
                    (_subsChad: any, index: number) => {
                      const isRowEnd =
                        (index + 1) % itemsPerRow === 0 &&
                        index + 1 < cartDetails.subscriptionChadhavas.length;
                      return (
                        <React.Fragment key={_subsChad.id}>
                          <Grid item xs={4} md={3}>
                            <ChadhavaItemList
                              name={_subsChad?.name || ""}
                              chadhavaPic={_subsChad?.image}
                              price={
                                isOverseas
                                  ? truncateToTwoDecimals(
                                      _subsChad?.priceInfo?.finalPriceOv,
                                    )
                                  : _subsChad?.priceInfo?.finalPrice
                              }
                              currency={currencySign}
                              checked={!!_subsChad?.count}
                              onSelectChange={() => {}}
                            />
                          </Grid>

                          {isRowEnd && (
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "1px",
                                  backgroundColor: "#707070",
                                }}
                              />
                            </Grid>
                          )}
                        </React.Fragment>
                      );
                    },
                  )}
                </Grid>
              </Box>
            )}
          {/* List of chadhava Subscriptions */}

          {chadhavaEnablity &&
            cartDetails?.isSubscribed &&
            cartDetails?.templeDetails?.chadhavaSubscription?.subscriptions
              ?.length && (
              <Box className="addDevotee chadhavaItems">
                <Box className="devoteeDetails">
                  <SubtitleTypography
                    title={`${t(LOCALIZATION.Chadhava_Subscription)}`}
                  ></SubtitleTypography>
                </Box>
                <Grid container spacing={2}>
                  {cartDetails?.templeDetails?.chadhavaSubscription?.subscriptions?.map(
                    (plan: any) => {
                      return (
                        <Grid item xs={12} key={plan?.subscriptionId}>
                          <ChadhavaPlanSelector
                            descriptionVariant="compact"
                            isPlanSelected={
                              plan?.subscriptionId ===
                              selectedChadhavaSubscription?.subscriptionId
                            }
                            title={plan?.title ?? ""}
                            description={plan?.description ?? ""}
                            onChange={() => {
                              handleChadhavaPlanSelection(plan);
                            }}
                            price={calculateDiscountedPrice(
                              isOverseas
                                ? subscriptionChadhavaAggPrice?.finalPriceOv
                                : subscriptionChadhavaAggPrice?.finalPrice,
                              Number(plan?.fixDiscount),
                            )}
                            currency={currencySign}
                            frequency={Number(plan?.frequency ?? 0) ?? 0}
                            discount={Number(plan?.fixDiscount ?? 0) ?? 0}
                            cuttedPrice={
                              isOverseas
                                ? truncateToTwoDecimals(
                                    subscriptionChadhavaAggPrice?.finalPriceOv *
                                      plan?.frequency,
                                  )
                                : truncateToTwoDecimals(
                                    subscriptionChadhavaAggPrice?.finalPrice *
                                      plan?.frequency,
                                  )
                            }
                          />
                        </Grid>
                      );
                    },
                  )}
                </Grid>
              </Box>
            )}

          {/* Chadhava Items */}
          {selectedChadhavaPackage?.length > 0 && (
            <Box className="addDevotee chadhavaItems">
              <Box className="devoteeDetails">
                <SubtitleTypography
                  title={`${t(cartPageTitle)} ${t(LOCALIZATION.Items)}`}
                ></SubtitleTypography>
              </Box>
              <Box className="formGroup">
                {selectedChadhavaPackage &&
                  selectedChadhavaPackage?.length > 0 &&
                  selectedChadhavaPackage?.map((item: any, index: number) => {
                    return (
                      <Box className="chadhavaItem">
                        <Box className="chadhavaLeft">
                          <Box className="itemImg">
                            {item?.image && (
                              <ImageView
                                src={item?.image}
                                alt="Selected Item"
                              />
                            )}
                          </Box>
                          <Box className="namePrice">
                            <Typography>{item?.name}</Typography>

                            <Box className="priceSection">
                              <Typography className="mainPrice">
                                {`${
                                  item?.priceInfo?.finalPrice
                                    ? props.getOverSeasPriceByRateText(
                                        item?.priceInfo?.finalPrice,
                                      )
                                    : "0.00"
                                } x ${item?.count}`}{" "}
                              </Typography>
                              {(item?.priceInfo?.offerActualPrice > 0 ||
                                item?.priceInfo?.offerActualPriceOv > 0) && (
                                <Typography
                                  variant="body2"
                                  className="cuttedPrice"
                                >
                                  {props.getOverSeasPriceByRateText(
                                    item?.priceInfo?.offerActualPriceOv
                                      ? item?.priceInfo?.offerActualPriceOv
                                      : item?.priceInfo?.offerActualPrice,
                                  )}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Box className="chadhavaRight">
                          <Box className="addItemsBtns">
                            <ButtonGroup className="btnsGroup">
                              <Button
                                variant="contained"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (isCountryDisabledForBooking) {
                                    setOpenAlertDialogForBookingNotAllowed(
                                      true,
                                    );
                                    return;
                                  }
                                  decrement(item);
                                }}
                              >
                                <RemoveIcon fontSize="small" />
                              </Button>
                              <Button variant="contained">{item?.count}</Button>
                              <Button
                                variant="contained"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (isCountryDisabledForBooking) {
                                    setOpenAlertDialogForBookingNotAllowed(
                                      true,
                                    );
                                    return;
                                  }
                                  increment(item);
                                }}
                              >
                                <AddIcon fontSize="small" />
                              </Button>
                            </ButtonGroup>
                          </Box>
                        </Box>
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          )}

          {/* Chadhava Add-ons */}

          {chadhavaList?.length > 0 && (prasadEnablity || chadhavaEnablity) && (
            <Box className="addDevotee chadhavaAddOnsItems">
              <Box className="devoteeDetails">
                <SubtitleTypography
                  title={`${t(cartPageTitle)} ${t(LOCALIZATION.Add_ons)}`}
                ></SubtitleTypography>
              </Box>
              <Box className="addOnsSlider">
                <Carousel
                  responsive={CHADHAVA_ADDON_SCROLL_RESPONSIVE}
                  swipeable={true}
                  draggable={true}
                  showDots={false}
                  keyBoardControl={true}
                  removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
                >
                  {chadhavaList?.map((item: any, index: number) => {
                    const minimumPrice = getMinimumPrice(item?.packages);
                    let calculatedPrice = 0;
                    if (cartDetails?.orderType === orderType.prasad) {
                      calculatedPrice = truncateToTwoDecimals(
                        item.count > 0
                          ? item.priceInfo?.finalPrice || 0
                          : !item?.packages || item?.packages?.length === 0
                            ? Number(item?.acctualPrice) || 0
                            : item.selectedPackage
                              ? item.selectedPackage?.priceInfo?.finalPrice || 0
                              : minimumPrice,
                      );
                    }

                    if (cartDetails?.orderType === orderType.chadhava) {
                      calculatedPrice =
                        item?.priceInfo?.finalPrice ?? item?.acctualPrice ?? 0;
                    }

                    const itemPrice =
                      cartDetails?.orderType === orderType.prasad
                        ? `₹${calculatedPrice}`
                        : props.getOverSeasPriceByRateText(calculatedPrice);

                    return (
                      <Box className="addOnsItems" key={`addOnsItemsX${index}`}>
                        <Box className="addOnsItem">
                          <Box className="imgBlock">
                            <ImageView src={item?.image} alt={item?.name} />
                          </Box>
                          {item?.isMostOfferedTag === true && (
                            <label>{t(LOCALIZATION.Most_offered)}</label>
                          )}
                          <Button
                            className="addBtn"
                            onClick={(e) => {
                              if (isCountryDisabledForBooking) {
                                setOpenAlertDialogForBookingNotAllowed(true);
                                return;
                              }
                              e.preventDefault();
                              addChadhava(item);
                            }}
                          >
                            {t(LOCALIZATION.ADD)}
                          </Button>
                        </Box>
                        <Box className="addOnsDescription">
                          <Box component="span" className="mainPrice">
                            <SubtitleTypography title={item?.name} />
                            <SubtitleTypography title={itemPrice} />
                          </Box>

                          {/* Strikethrough Price */}
                          {(item?.priceInfo?.offerActualPrice > 0 ||
                            item?.priceInfo?.offerActualPriceOv > 0) && (
                            <Typography variant="body2" className="cuttedPrice">
                              {props.getOverSeasPriceByRateText(
                                item?.priceInfo?.offerActualPriceOv
                                  ? item?.priceInfo?.offerActualPriceOv
                                  : item?.priceInfo?.offerActualPrice,
                              )}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    );
                  })}
                </Carousel>
              </Box>
            </Box>
          )}

          {/* Offer Dakshina to Pandit ji */}
          {(chadhavaEnablity || chadhavaPkgEnablity) && (
            <Box className="addDevotee dakshinaPandit">
              <Box className="devoteeDetails">
                <SubtitleTypography
                  title={t(LOCALIZATION.Offer_Dakshina_to_Pandit_ji)}
                ></SubtitleTypography>
              </Box>
              <Box className="offerDakshina">
                <ParagraphTypography
                  title={`${t(
                    LOCALIZATION.Your_dakshina_will_be_given_to_the_pandit_ji,
                  )}`}
                />
                <Box className="dakshinaCheck">
                  <RadioGroup
                    className="checkItems"
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    sx={{
                      display: "flex",
                      flexWrap: "nowrap",
                      gap: "1rem",
                      alignItems: "center",
                      overflowX: "auto",
                      overflowY: "hidden",
                      whiteSpace: "nowrap",
                      padding: "0.5rem",
                    }}
                  >
                    {dakshinaPandit?.map((item: any, index: number) => {
                      const hasChip = item === 31;
                      return (
                        <FormControlLabel
                          key={`customDakshina${index}`}
                          value={item}
                          control={<Radio />}
                          label={
                            <Box>
                              {hasChip && (
                                <Chip
                                  label={t(LOCALIZATION.Most_Given)}
                                  color="primary"
                                  size="small"
                                  className="nwlyAddedbadge"
                                />
                              )}
                              {/* {`₹ ${item}`} */}
                              {props.getOverSeasPriceByRateText(Number(item))}
                            </Box>
                          }
                          className={hasChip ? "chipPresent" : ""}
                          checked={selectedDakshina === item}
                          onClick={() => {
                            props.setPanditDakshina(item);
                            setSelectedDakshina(item);
                            setCustomDakshina(0);
                            setIsEditing(false);
                          }}
                          sx={{
                            minWidth: "100px",
                            textAlign: "center",
                          }}
                        />
                      );
                    })}

                    {isEditing ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{
                          minWidth: "100px",
                          flexShrink: 0,
                          height: "52px",
                        }}
                      >
                        <TextField
                          value={customDakshina}
                          onChange={handleSetCutstomDakshinaChange}
                          onBlur={handleSetCutstomDakshinaBlur}
                          onKeyDown={handleSetCutstomDakshinaKeyDown}
                          variant="outlined"
                          size="small"
                          className="customDakshinaTextArea"
                          inputProps={{
                            style: {
                              textAlign: "center",
                              height: "36px",
                              padding: "8px 0",
                            },
                          }}
                          autoFocus
                          sx={{
                            height: "100%",
                            "& .MuiOutlinedInput-root": {
                              height: "100%",
                            },
                          }}
                        />
                      </Box>
                    ) : (
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{
                          minWidth: "100px",
                          flexShrink: 0,
                          height: "52px",
                        }}
                      >
                        <FormControlLabel
                          value={customDakshina}
                          control={<Radio />}
                          onClick={handleLabelClick}
                          label={`${props.currencySign} ${
                            customDakshina == 0
                              ? t(LOCALIZATION.Custom)
                              : customDakshina
                          }`}
                          className="customDakshinaCardArea"
                          checked={
                            customDakshina > 0 &&
                            selectedDakshina === customDakshina
                          }
                        />
                      </Box>
                    )}
                  </RadioGroup>
                </Box>

                <Box className="checkForFuture">
                  {/* <FormGroup>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Add this Dakshina amount in all my future offerings"
                  />
                </FormGroup> */}
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <Checkbox className="checkBoxFuture" defaultChecked />
                    <Typography className="checkForFutureText" component="p">
                      {t(
                        LOCALIZATION.Add_this_Dakshina_amount_in_all_my_future_offerings,
                      )}
                    </Typography>
                  </Stack>
                </Box>
              </Box>
            </Box>
          )}

          {/* Bill Details */}
          {/* <Box className="addDevotee billDetails">
            <Box className="billTitle">
              <SubtitleTypography title="Bill Details"></SubtitleTypography>
            </Box>
            <Box className="billLists">
              <List>
                <ListItem>
                  <ParagraphTypography title="Chadhava Value" />
                  <ParagraphTypography title="₹ 151.00" />
                </ListItem>
                <ListItem>
                  <ParagraphTypography title="Pandit Dakshina" />
                  <ParagraphTypography title="₹ 21.00" />
                </ListItem>
                <ListItem>
                  <ParagraphTypography title="GST" />
                  <ParagraphTypography title="₹ 27.18" />
                </ListItem>
                <ListItem>
                  <ParagraphTypography title="Total Amount" />
                  <ParagraphTypography title="₹ 199.18" />
                </ListItem>
              </List>
            </Box>
          </Box> */}

          {/* Payment Details */}
          {/* <Box className="addDevotee paymentBlock">
            <Box className="paymentOption">
              <Box className="payOption">
                <FormControl className="paymentType">
                  <InputLabel id="demo-simple-select-label">
                    Pay using
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Pay using"
                  >
                    <MenuItem value={10} className="menuItem" selected>
                      <span>
                        <img src={PhonePe} />
                      </span>{" "}
                      PhonePe
                    </MenuItem>
                    <MenuItem value={20} className="menuItem">
                      <span>
                        <img src={PayTm} />
                      </span>{" "}
                      Paytm
                    </MenuItem>
                    <MenuItem value={30} className="menuItem">
                      <span>
                        <img src={BankImg} />
                      </span>{" "}
                      Net Banking
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box className="payNow">
                <Button className="btnPayNow">₹ 199.18</Button>
              </Box>
            </Box>
          </Box> */}
        </Box>
      ) : null}

      {/* ----- Puja Booking Checkout Cart ----- */}
      <Box className="cartDetails pujaBookingDetails">
        {(pujaPkgEnablity || chadhavaPkgEnablity) && (
          <Box className="pujaBookingDetails">
            <CartPackageDetails cartDetails={cartDetails} />
          </Box>
        )}

        <Box className="pujaBookingDetails">
          {(pujaEnablity || pujaPkgEnablity || chadhavaPkgEnablity) && (
            <>
              {pujaEnablity && (
                <>
                  <SubtitleTypography
                    className="topTitle"
                    title={t(LOCALIZATION.Review_Puja_Booking_Details)}
                  ></SubtitleTypography>
                  <Box className="cardDesign pujaInformation">
                    <Stack
                      className="pujaInfoTop"
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Box className="pujaNameDate">
                        <Typography className="pujaName">
                          {props?.cartDetails?.pujaDetails?.pujaName}
                        </Typography>
                        {!cartDetails?.isSubscribed && (
                          <Typography>
                            Puja Performing Date:{" "}
                            {`${getDateFormatedForPujaDetails(
                              props?.cartDetails?.bookedForDate?.pujaDate,
                            )}`}
                          </Typography>
                        )}
                      </Box>
                      <Box className="pujaImage">
                        <ImageView
                          src={props?.cartDetails?.pujaDetails?.pujaBg?.uri}
                          alt="puja Image"
                          width={60}
                          height={60}
                          sizes="(max-width: 768px) 60px, 60px"
                        />
                      </Box>
                    </Stack>
                    <Box className="pujaInfoBottom">
                      <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                        className="templeName"
                      >
                        <img src={TempleImg} alt="" />
                        <Typography>{templeName}</Typography>
                      </Stack>
                      {templeAddress?.trim().length > 0 && (
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={1}
                          className="templeAddress"
                        >
                          <img src={LocationImg} alt="" />
                          {/* <Typography>{`${props?.cartDetails?.templeDetails?.personalInfo?.address?.area}, ${props?.cartDetails?.templeDetails?.personalInfo?.address?.state}`}</Typography> */}
                          <Typography>{templeAddress}</Typography>
                        </Stack>
                      )}
                    </Box>
                  </Box>
                </>
              )}

              {/* Address */}
              {
                userDetails && (pujaEnablity || pujaPkgEnablity) ? (
                  <>
                    <Box className="cardDesign addressSce">
                      <Typography className="addressTitle">
                        {/* {" "}
                  {props.selectedAddressDetails
                    ? props.selectedAddressDetails.savedAs ||
                    props.selectedAddressDetails.name
                    : "Address"} */}
                        {t(LOCALIZATION.Address)}
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        marginTop="10px"
                        spacing={1}
                        onClick={() => {
                          if (props.selectedAddressDetails) {
                            props.setChooseAddressBox(true);
                          } else {
                            props.navigateToAddressScreen();
                          }
                        }}
                      >
                        <Box className="addressText">
                          <PersonPinCircleOutlinedIcon />
                          {props.selectedAddressDetails ? (
                            <Box>
                              <Typography className="areaInfo">
                                {props.selectedAddressDetails.savedAs}
                              </Typography>
                              <Typography className="locationInfo">
                                {
                                  props.selectedAddressDetails.formatted_address
                                }{" "}
                              </Typography>
                            </Box>
                          ) : (
                            <Box className="addressText">
                              <Typography>
                                {t(LOCALIZATION.Plese_Add_Your_Address)}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        <Box className="arrowBtn">
                          <Button variant="text">
                            <EastIcon />
                          </Button>
                        </Box>
                      </Stack>
                    </Box>
                  </>
                ) : (
                  " "
                )
                // <Box className="logoutCartArea">
                //   <Box className="logoutCartAreaLeft">
                //     <Typography>
                //       {t(LOCALIZATION.You_Are_Not_Logged_In_Please_Login)}
                //     </Typography>
                //   </Box>
                //   <Box className="logoutCartAreaRight">
                //     <Button
                //       type="button"
                //       onClick={() => props.navigateToLoginScreen()}
                //     >
                //       {t(LOCALIZATION.Login_OR_Signup)}
                //     </Button>
                //   </Box>
                // </Box>
              }
              <Box className="cardDesign devoteeDetails">
                <Typography className="devoteeTitle">
                  {t(LOCALIZATION.Devotee_Details)}
                </Typography>
                <Box className="devoteeNameSec">
                  <Typography className="devoteeNameTitle">
                    {t(LOCALIZATION.Devotee_Added)}
                  </Typography>
                  <Box className="nameArea">
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      {props.memberDetails.map((item: any, id: any) => {
                        return (
                          <Grid item md={4} lg={3}>
                            <Chip className="boxColor" label={item.fullName} />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                  <Stack
                    className="devoteeBottom"
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                  >
                    <Typography className="devoteeCount">
                      X {props.memberDetails.length} {t(LOCALIZATION.Devotees)}
                    </Typography>
                    <Button
                      variant="contained"
                      endIcon={<EditIcon />}
                      className="editCart"
                      onClick={() => {
                        props.editPujaOptions();
                      }}
                    >
                      {t(LOCALIZATION.Edit_Details)}
                    </Button>
                    <button
                      type="button"
                      className="deleteCart"
                      onClick={() => {
                        //props.clearCart();
                        handleDeleteClick();
                      }}
                    >
                      <DeleteIcon />
                    </button>
                  </Stack>
                </Box>
              </Box>

              {pujaEnablity &&
                cartDetails?.isSubscribed &&
                cartDetails?.pujaDetails?.pujaSubscription?.subscriptions
                  ?.length && (
                  <Box className="addDevotee chadhavaItems">
                    <Box className="devoteeDetails">
                      <SubtitleTypography
                        title={`${t(LOCALIZATION.Puja_Subscription)}`}
                      ></SubtitleTypography>
                    </Box>
                    <Grid container spacing={2}>
                      {cartDetails?.pujaDetails?.pujaSubscription?.subscriptions?.map(
                        (plan: any) => {
                          return (
                            <Grid item xs={12} key={plan?.subscriptionId}>
                              <PujaPlanSelector
                                descriptionVariant="compact"
                                isPlanSelected={
                                  plan?.subscriptionId ===
                                  selectedPujaSubscription?.subscriptionId
                                }
                                title={plan?.title ?? ""}
                                description={plan?.description ?? ""}
                                onChange={() => {
                                  handlePujaPlanSelection(plan);
                                }}
                                // needed to change
                                price={calculateDiscountedPrice(
                                  isOverseas
                                    ? singlePujaPrice?.finalPrice * rate
                                    : singlePujaPrice?.finalPrice,
                                  Number(plan?.fixDiscount),
                                )}
                                currency={currencySign}
                                frequency={Number(plan?.frequency ?? 0) ?? 0}
                                discount={Number(plan?.fixDiscount ?? 0) ?? 0}
                                // need to change
                                cuttedPrice={
                                  isOverseas
                                    ? truncateToTwoDecimals(
                                        singlePujaPrice?.finalPrice *
                                          plan?.frequency *
                                          rate,
                                      )
                                    : truncateToTwoDecimals(
                                        singlePujaPrice?.finalPrice *
                                          plan?.frequency,
                                      )
                                }
                              />
                            </Grid>
                          );
                        },
                      )}
                    </Grid>
                  </Box>
                )}

              {/* Offer Dakshina to Pandit ji */}
              {chadhavaPkgEnablity && (
                <Box className="addDevotee dakshinaPandit">
                  <Box className="devoteeDetails">
                    <SubtitleTypography
                      title={t(LOCALIZATION.Offer_Dakshina_to_Pandit_ji)}
                    ></SubtitleTypography>
                  </Box>
                  <Box className="offerDakshina">
                    <ParagraphTypography
                      title={`${t(
                        LOCALIZATION.Your_dakshina_will_be_given_to_the_pandit_ji,
                      )}`}
                    />
                    <Box className="dakshinaCheck">
                      <RadioGroup
                        className="checkItems"
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        sx={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: "1rem",
                          alignItems: "center",
                          overflowX: "auto",
                          overflowY: "hidden",
                          whiteSpace: "nowrap",
                          padding: "0.5rem",
                        }}
                      >
                        {dakshinaPandit?.map((item: any, index: number) => {
                          const hasChip = item === 31;
                          return (
                            <FormControlLabel
                              key={`customDakshina${index}`}
                              value={item}
                              control={<Radio />}
                              label={
                                <Box>
                                  {hasChip && (
                                    <Chip
                                      label={t(LOCALIZATION.Most_Given)}
                                      color="primary"
                                      size="small"
                                      className="nwlyAddedbadge"
                                    />
                                  )}
                                  {/* {`₹ ${item}`} */}
                                  {props.getOverSeasPriceByRateText(
                                    Number(item),
                                  )}
                                </Box>
                              }
                              className={hasChip ? "chipPresent" : ""}
                              checked={selectedDakshina === item}
                              onClick={() => {
                                props.setPanditDakshina(item);
                                setSelectedDakshina(item);
                                setCustomDakshina(0);
                                setIsEditing(false);
                              }}
                              sx={{
                                minWidth: "100px",
                                textAlign: "center",
                              }}
                            />
                          );
                        })}

                        {isEditing ? (
                          <Box
                            display="flex"
                            alignItems="center"
                            sx={{
                              minWidth: "100px",
                              flexShrink: 0,
                              height: "52px",
                            }}
                          >
                            <TextField
                              value={customDakshina}
                              onChange={handleSetCutstomDakshinaChange}
                              onBlur={handleSetCutstomDakshinaBlur}
                              onKeyDown={handleSetCutstomDakshinaKeyDown}
                              variant="outlined"
                              size="small"
                              className="customDakshinaTextArea"
                              inputProps={{
                                style: {
                                  textAlign: "center",
                                  height: "36px",
                                  padding: "8px 0",
                                },
                              }}
                              autoFocus
                              sx={{
                                height: "100%",
                                "& .MuiOutlinedInput-root": {
                                  height: "100%",
                                },
                              }}
                            />
                          </Box>
                        ) : (
                          <Box
                            display="flex"
                            alignItems="center"
                            sx={{
                              minWidth: "100px",
                              flexShrink: 0,
                              height: "52px",
                            }}
                          >
                            <FormControlLabel
                              value={customDakshina}
                              control={<Radio />}
                              onClick={handleLabelClick}
                              label={`${props.currencySign} ${
                                customDakshina == 0
                                  ? t(LOCALIZATION.Custom)
                                  : customDakshina
                              }`}
                              className="customDakshinaCardArea"
                              checked={
                                customDakshina > 0 &&
                                selectedDakshina === customDakshina
                              }
                            />
                          </Box>
                        )}
                      </RadioGroup>
                    </Box>

                    <Box className="checkForFuture">
                      {/* <FormGroup>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Add this Dakshina amount in all my future offerings"
                  />
                </FormGroup> */}
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="flex-start"
                        alignItems="flex-start"
                      >
                        <Checkbox className="checkBoxFuture" defaultChecked />
                        <Typography
                          className="checkForFutureText"
                          component="p"
                        >
                          {t(
                            LOCALIZATION.Add_this_Dakshina_amount_in_all_my_future_offerings,
                          )}
                        </Typography>
                      </Stack>
                    </Box>
                  </Box>
                </Box>
              )}

              {/* <Box className="cardDesign offerZone">
                <Typography className="offerZoneTitle">Offers Zone</Typography>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                  className="couponCodeTop"
                >
                  {props.couponApplyResponse.isApplied ? (
                    <>
                      <Box className="couponApplySec">
                        <img src={couponApplyIcon} alt="" />
                        <Box>
                          <Typography className="couponText">
                            Devotee(s) saved <span>₹{priceData.discount}</span>{" "}
                            with coupon code{" "}
                            <span className="cupCodeText">
                              {
                                props.couponApplyResponse?.couponData
                                  ?.couponCode
                              }{" "}
                            </span>
                          </Typography>
                        </Box>
                      </Box>
                      <Box className="removeBtn">
                        <Button
                          variant="text"
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            props.setCouponApplyResponse({
                              ...props.couponApplyResponse,
                              isApplied: false,
                              isValid: false,
                            });

                            props.setPriceQuoteForPuja();
                          }}
                        >
                          Remove
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <Stack
                      onClick={() => props.setCouponPopUp(true)}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                      className="couponCodeBottom"
                    >
                      <Box className="couponApplySec">
                        <img src={couponPercentIcon} alt="" />
                        <Box>
                          <Typography className="couponText">
                            View other coupons
                          </Typography>
                        </Box>
                      </Box>
                      <Box className="arrowBtn">
                        <Button variant="text">
                          <EastIcon />
                        </Button>
                      </Box>
                    </Stack>
                  )}
                </Stack>
              </Box> */}
            </>
          )}
          {(pujaEnablity || pujaPkgEnablity) &&
            typeof props.selectedAddressDetails !== "undefined" && (
              <Box className="cardDesign prasadCheckbox">
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="mainAcceptPrasadBox"
                >
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                    className="acceptPrasadCheckBox"
                  >
                    <Switch
                      color="primary"
                      onChange={handlePrasadCheckboxChange}
                      checked={isPrasad === true}
                    />
                    <Typography>
                      {t(LOCALIZATION.Would_you_like_to_receive_Prasad)}
                    </Typography>
                  </Stack>
                  <Box className="prasadImage">
                    <img src={prasadImg} alt="Prasad" />
                  </Box>
                </Stack>
                <Typography className="disclaimer">
                  <ErrorOutlineIcon />
                  {t(LOCALIZATION.Prasad_Delivery_Is_Only_Available_In_India)}
                </Typography>
              </Box>
            )}

          {userDetails?.phoneNumber && pujaEnablity && !cartDetails?.isSubscribed && (
            <Box className="cardDesign offerZone">
              <Typography className="offerZoneTitle">
                {" "}
                {t(LOCALIZATION.Offers_Zone)}
              </Typography>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
                className="couponCodeTop"
              >
                {props.couponApplyResponse.isApplied ? (
                  <>
                    <Box className="couponApplySec">
                      <img src={couponApplyIcon} alt="" />
                      <Box>
                        <Typography className="couponText">
                          {t(LOCALIZATION.Devotee_saved)}{" "}
                          <span>
                            {/* ₹{priceData.discount} */}
                            {props.getOverSeasPriceByRateText(
                              priceData?.discount,
                            )}
                          </span>{" "}
                          {t(LOCALIZATION.with_coupon_code)}{" "}
                          <span className="cupCodeText">
                            {
                              props.couponApplyResponse?.couponData?.couponCode
                            }{" "}
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="removeBtn">
                      <Button
                        variant="text"
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          props.setCouponApplyResponse({
                            ...props.couponApplyResponse,
                            isApplied: false,
                            isValid: false,
                          });

                          props.setPriceQuoteForPuja();
                        }}
                      >
                        {t(LOCALIZATION.REMOVE)}
                      </Button>
                    </Box>
                  </>
                ) : (
                  <Stack
                    onClick={() => props.setCouponPopUp(true)}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    className="couponCodeBottom"
                  >
                    <Box className="couponApplySec">
                      <img src={couponPercentIcon} alt="" />
                      <Box>
                        <Typography className="couponText">
                          {t(LOCALIZATION.View_other_coupons)}
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="arrowBtn">
                      <Button variant="text">
                        <EastIcon />
                      </Button>
                    </Box>
                  </Stack>
                )}
              </Stack>
            </Box>
          )}

          <Box
            className={`cardDesign billDetails ${
              prasadEnablity ? "prasadMbAdd" : ""
            }`}
          >
            <Typography className="billDetailsTitle">
              {t(LOCALIZATION.Bill_Details)}
            </Typography>
            <Box className="detailList">
              {pujaEnablity && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>{t(LOCALIZATION.Puja_Value)}</Typography>
                  {/* <Typography>{`₹ ${props?.previousPriceData}/-`}</Typography> */}
                  {cartDetails?.isSubscribed && (
                    <Typography>{`${props.getOverSeasPriceByRateText(
                      props?.previousPriceData,
                    )}`}</Typography>
                  )}
                  {!cartDetails?.isSubscribed && (
                    <Typography>
                      {`${props.getOverSeasPriceByRateText(
                        (priceBreakup?.corePrice ?? 0) +
                          (priceBreakup?.gst ?? 0),
                      )}`}{" "}
                    </Typography>
                  )}
                </Stack>
              )}
              {pujaEnablity && isPrasad && !cartDetails?.isSubscribed && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>{t(LOCALIZATION.Delivary_Fee)}</Typography>
                  <Typography>{`${props.getOverSeasPriceByRateText(
                    (priceBreakup?.priceBreakup?.delivery ?? 0) +
                      (priceBreakup?.priceBreakup?.goodies ?? 0) +
                      (priceBreakup?.priceBreakup?.packaging ?? 0),
                  )}`}</Typography>
                </Stack>
              )}
              {pujaPkgEnablity && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>{t(LOCALIZATION.Package_Value)}</Typography>
                  <Typography>{`${props.getOverSeasPriceByRateText(
                    props?.previousPriceData,
                  )}`}</Typography>
                </Stack>
              )}

              {chadhavaPkgEnablity && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  {/* 
                    props.panditDakshina > 0
                      ? props.getOverSeasPriceByRateText(props.panditDakshina)
                      : props.getOverSeasPriceByRateText(selectedDakshina) || 0
                   */}

                  <Typography>{t(LOCALIZATION.Package_Value)}</Typography>
                  <Typography>{`${currencySign}${truncateToTwoDecimals(
                    ((priceBreakup?.actualPujaPrice ?? 0) +
                      (priceBreakup?.gst ?? 0)) *
                      rate,
                  )}`}</Typography>
                </Stack>
              )}

              {chadhavaEnablity && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>
                    {t(cartPageTitle)} {t(LOCALIZATION.Value)}
                  </Typography>
                  <Typography className="">
                    {`${props.getOverSeasPriceByRateText(
                      props?.getChadhavaTotalValue() || 0,
                      isOverseas,
                    )}`}
                  </Typography>
                </Stack>
              )}
              {prasadEnablity && (
                <>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className="listItem"
                  >
                    <Typography>
                      {t(cartPageTitle)} {t(LOCALIZATION.Value)}
                    </Typography>
                    <Typography className="">
                      {`₹${truncateToTwoDecimals(
                        priceBreakup?.finalPrice -
                          ((priceBreakup?.priceBreakup?.delivery || 0) +
                            (priceBreakup?.priceBreakup?.packaging || 0) +
                            (priceBreakup?.otherGst || 0)),
                      )}`}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className="listItem"
                  >
                    <Typography>
                      {`${t(LOCALIZATION.Delivary)} + ${t(
                        LOCALIZATION.Packaging,
                      )}`}
                    </Typography>
                    <Typography className="">
                      {`₹${truncateToTwoDecimals(
                        (priceBreakup?.priceBreakup?.delivery || 0) +
                          (priceBreakup?.priceBreakup?.packaging || 0) +
                          (priceBreakup?.otherGst || 0),
                      )}`}
                    </Typography>
                  </Stack>
                </>
              )}
              {(chadhavaEnablity || chadhavaPkgEnablity) && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>{t(LOCALIZATION.Pandit_Dakshina)}</Typography>
                  <Typography className="">
                    {/* {props.currencySign} */}
                    {props.panditDakshina > 0
                      ? props.getOverSeasPriceByRateText(props.panditDakshina)
                      : props.getOverSeasPriceByRateText(selectedDakshina) || 0}
                  </Typography>
                </Stack>
              )}

              {priceData?.discount ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography className="couponCode">
                    {t(LOCALIZATION.Coupon_Applied)}{" "}
                    <span>
                      ({props.couponApplyResponse?.couponData?.couponCode})
                    </span>
                  </Typography>
                  <Typography className="couponCodeDiscount">
                    {/* {`₹ ${priceData.discount}/-`} */}-{" "}
                    {props.getOverSeasPriceByRateText(priceData?.discount)}
                  </Typography>
                </Stack>
              ) : null}
              {/* {pujaEnablity ? (<Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className="listItem"
              >
                <Typography>GST</Typography>
                <Typography>{`₹ ${priceData.gst}/-`}</Typography>
              </Stack>) : ""} */}

              {priceData?.discount ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>{t(LOCALIZATION.Total)}</Typography>
                  <Typography className="totalAmountCut">
                    {/* {props.getOverSeasPriceByRateText(
                      props?.previousPriceData ?? 0
                    )} */}
                    {props.getOverSeasPriceByRateText(
                      (priceBreakup?.corePrice ?? 0) +
                        (priceBreakup?.gst ?? 0) +
                        (priceBreakup?.priceBreakup?.delivery ?? 0) +
                        (priceBreakup?.priceBreakup?.goodies ?? 0) +
                        (priceBreakup?.priceBreakup?.packaging ?? 0),
                    )}
                    {/* ₹{Math.ceil(props?.previousPriceData || 0)} */}
                  </Typography>
                </Stack>
              ) : null}

              {/* { chadhavaEnablity && priceData.discount ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="listItem"
                >
                  <Typography>Total</Typography>
                  <Typography className="totalAmountCut">
                    ₹{priceData?.actualFinalPrice || 0}
                  </Typography>
                </Stack>
              ) : null} */}

              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className="listItem"
              >
                <Typography>
                  <span>{t(LOCALIZATION.Final_Payment)}</span>
                </Typography>
                <Typography>
                  {/* <span>{`₹ ${
                    priceData.finalPrice
                      ? Math.ceil(Number(priceData.finalPrice))
                      : "0.00"
                  }/-`}</span> */}
                  {`${
                    chadhavaEnablity || prasadEnablity
                      ? isOverseas
                        ? getSymbolWithPrice(getChadhavaFinalPaymentValue())
                        : props.getOverSeasPriceByRateText(
                            props.getChadhavaFinalPaymentValue(),
                            isOverseas,
                          )
                      : props.getOverSeasPriceByRateText(priceData?.finalPrice)
                  }/-`}
                </Typography>
              </Stack>
            </Box>
          </Box>

          {userDetails
            ? !prasadEnablity && (
                <Box className="cardDesign userDetails">
                  <Typography className="userDetailsTitle">
                    {t(LOCALIZATION.User_Details)}
                  </Typography>
                  <Box className="userDetailList">
                    <Typography>
                      {props.userPersonalInfo.firstName}{" "}
                      {props.userPersonalInfo.lastName}
                    </Typography>
                    <Typography>
                      {" "}
                      {props?.userDetails?.phoneNumber?.substring(0, 7)}XXXX
                      {props?.userDetails?.phoneNumber?.substring(
                        props?.userDetails?.phoneNumber?.length - 2,
                        props?.userDetails?.phoneNumber?.length,
                      )}
                    </Typography>
                    {/* <Typography>{props.userPersonalInfo.email}</Typography> */}
                  </Box>
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    sx={{
                      alignItems: {
                        xs: "flex-start",
                        md: "center",
                      },
                    }}
                    spacing={1}
                    className="mailAcceptDetail"
                  >
                    <Checkbox className="checkBox" />
                    <Typography>
                      {t(LOCALIZATION.I_want_to_receive_transaction)}
                    </Typography>
                  </Stack>
                </Box>
              )
            : null}
          {/* Cancellation Policy */}
          {!prasadEnablity && (
            <Box className="cardDesign cancellationPolicy">
              <Typography className="cancelPolicyTitle">
                {t(LOCALIZATION.Cancellation_Policy)}
              </Typography>
              <Box className="policyText">
                <Typography>
                  {t(LOCALIZATION.Orders_can_be_cancelled)}
                </Typography>
              </Box>
            </Box>
          )}

          {/* Proceed to Payment BTN */}

          <Box
            className="paymentBtn desktopOnly sticky-button"
            sx={{ position: `${isAboveFooter ? "absolute" : "fixed"}` }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography>
                {`${
                  chadhavaEnablity || prasadEnablity
                    ? isOverseas
                      ? getSymbolWithPrice(getChadhavaFinalPaymentValue())
                      : props.getOverSeasPriceByRateText(
                          props.getChadhavaFinalPaymentValue(),
                          isOverseas,
                        )
                    : props.getOverSeasPriceByRateText(priceData?.finalPrice)
                }/-`}
              </Typography>

              {userDetails ? (
                <Button
                  variant="contained"
                  onClick={(e: any) => {
                    handleClickProceedToPayment(e);
                  }}
                  disabled={isLoadingPayment}
                >
                  {isLoadingPayment ? (
                    <CircularProgress size={15} />
                  ) : (
                    t(LOCALIZATION.PROCEED_TO_PAYMENT)
                  )}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={(e: any) => props.navigateToLoginScreen()}
                >
                  {t(LOCALIZATION.Login)}
                </Button>
              )}
            </Stack>
          </Box>
        </Box>

        <Dialog
          className="startPostInput"
          onClose={() => {
            setChooseAddressBox(false);
            if (selectedAddressDetails?.countryCode !== "IN") {
              setIsPrasad(false);
            }
          }}
          open={props.chooseAddressBox}
        >
          <ChooseAddress
            userPersonalInfo={props.userPersonalInfo}
            changeDeliverytAddress={props.changeDeliverytAddress}
            setChooseAddressBox={props.setChooseAddressBox}
          />
        </Dialog>

        {/* <Dialog
        className="Orderresult"
        onClose={() => props.setOrderCreatedScreen(false)}
        open={props.orderCreatedScreen}
      >
        <Box style={{ width: "20em", height: "15em",padding:"1em" }}>
          <Typography style={{marginTop:"1em"}}>
          Your order Created Successfully
          </Typography>
          <Typography style={{fontWeight: "bold"}}>
          Order Id : {props.orderResultDetails}
          </Typography>
         <Button onClick={()=>{dispatch(setCartItems([]));}}>Ok</Button>
        </Box>
      </Dialog> */}

        <Dialog
          className="warnMsg"
          onClose={() =>
            props.setErrorPopUp({ isError: false, errorMessages: [] })
          }
          open={props.errorPopup.isError}
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: "14px",
            },
          }}
        >
          <Box className="warnCard">
            <Box display="flex" alignItems="flex-start">
              <ErrorOutlineRoundedIcon />
              <Typography className="textMessage">
                {t(
                  LOCALIZATION.Please_take_action_on_below_items_before_submiting,
                )}
              </Typography>
            </Box>
            {props.errorPopup.errorMessages.map((item: any, id: any) => {
              if (item.errType === "addressNotGiven") {
                return (
                  <Stack
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                    spacing={1}
                    sx={{ margin: "20px 0 10px" }}
                  >
                    <Typography className="warnItem">{item.message}</Typography>
                    <Button
                      className="warnAction"
                      onClick={() => props.navigateToAddressScreen()}
                    >
                      {t(LOCALIZATION.Add_Address)}
                    </Button>
                  </Stack>
                );
              } else if (item.errType === "memberNotSelected") {
                return (
                  <Stack
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                    spacing={1}
                    sx={{ margin: "20px 0 10px" }}
                  >
                    <Typography className="warnItem">{item.message}</Typography>
                    <Button
                      className="warnAction"
                      onClick={() => props.navigateToAddMembersScreen()}
                    >
                      Add Members +
                    </Button>
                  </Stack>
                );
              } else {
                return null;
              }
              // return <Box><Typography className="warnItem">
              //   {item.message}</Typography>

              //   <Button></Button>
              //   </Box>;
            })}
            <Button
              sx={{ marginTop: "30px" }}
              className="btnNext"
              variant="contained"
              onClick={() =>
                props.setErrorPopUp({ isError: false, errorMessages: [] })
              }
            >
              {t(LOCALIZATION.OK)}
            </Button>
          </Box>
        </Dialog>

        <CouponCodeDialog
          open={props.couponPopup}
          onClose={() => props.setCouponPopUp(false)}
          allActiveCoupons={props.allActiveCoupons}
          setCouponCodeData={props.setCouponCodeData}
          checkValidityOfcoupon={props.checkValidityOfcoupon}
          couponApplyResponse={props.couponApplyResponse}
          couponCodeType={chadhavaEnablity ? "CHADHAVA" : "PUJA"}
          // handleSetCouponApplyResponse={handleSetCouponApplyResponse}
        />

        <DeleteConfirmDialog
          open={isDialogOpen}
          onClose={handleCloseDialog}
          onConfirm={handleConfirmDelete}
          msg={t(
            LOCALIZATION.Do_You_Really_Want_To_Clear_Everything_From_Your_Cart,
          )}
        />

        <AlertDialog
          open={outSideIndiaMessagePopup}
          onClose={() => {
            setOutSideIndiaMessagePopup(false);
          }}
          message={t(LOCALIZATION.Bookings_are_not_permitted_in_your_country)}
        />
        {/* Oops! */}

        {/* <Dialog
        className="errorMsg"
        onClose={() => props.setBookingFailedPopUp(false)}
        open={props.bookingFailedPopup}
      >
        <Typography>Sorry for inconvenience. Error happened while booking the Puja. Please try again after sometime !</Typography>
        <Button onClick={() => props.setBookingFailedPopUp(false)}>Ok</Button>
      </Dialog> */}
        <AlertDialog
          open={openPriceErrorDialog}
          onClose={handleCloseAlertDialogForPrice}
          message={t(LOCALIZATION.Bookings_are_not_permitted_for_below, {
            currency: isOverseas ? props?.currencySign : "₹",
            amount: isOverseas
              ? minOrderValue?.minBookingChadhavaPriceOverseas
              : minOrderValue?.minBookingChadhavaPriceIND,
          })}
        />
        <AlertDialog
          open={openAlertDialogForBookingNotAllowed}
          onClose={handleCloseAlertDialogForBookingNotAllowed}
          message={
            [orderType?.chadhava, orderType?.puja].includes(
              cartDetails?.orderType,
            )
              ? POP_UP_MESSAGE?.bookingErrorMessagePujaChadhava
              : POP_UP_MESSAGE?.bookingErrorMessagePrasad
          }
        />
        <SelectPrasadPackageDilog
          open={isPrasadPkgOpen}
          selectedPrasad={selectedPrasadItem}
          onClose={() => {
            setIsPrasadPkgOpen(false);
            setSelectedPrasadItem(null);
          }}
          handleSelectPrasadPkg={handleSelectPrasadPkg}
        />
      </Box>
    </Box>
  );
}

export default ReviewCartView;
